







































import VTabsHash from '@/components/VTabsHash.vue';
import SuperAdminConfigurationCopyStake from '@/views/SuperAdminViews/super-admin-configuration/SuperAdminConfigurationCopyStake.vue';
import SuperAdminConfigurationCopyStakeAiStreamer from '@/views/SuperAdminViews/super-admin-configuration/SuperAdminConfigurationCopyStakeAiStreamer.vue';

const ETabKey: { [key: string]: string } = {
  COPY_STAKE: 'COPY_STAKE',
  COPY_STAKE_AI_STREAMER: 'COPY_STAKE_AI_STREAMER'
};

export default {
  name: 'SuperAdminConfigurationView',
  components: {
    VTabsHash,
    SuperAdminConfigurationCopyStake,
    SuperAdminConfigurationCopyStakeAiStreamer
  },
  data: (): any => ({
    currentTab: 0,
    tabs: [
      {
        id: ETabKey.COPY_STAKE,
        text: 'CopyStake',
        component: 'SuperAdminConfigurationCopyStake',
        showSearchInput: true
      },
      {
        id: ETabKey.COPY_STAKE_AI_STREAMER,
        text: 'CopyStake (AI Streamer)',
        component: 'SuperAdminConfigurationCopyStakeAiStreamer',
        showSearchInput: false
      }
    ] as any[],
    searchPhrase: ''
  })
};
